export default "./dist/stdassets/images/icons/icon_home.png";